"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const StyleWrapper = (props) => {
    const { children, textColor, backgroundColor } = props;
    return react_1.default.createElement("div", { style: {
            color: textColor,
            backgroundColor: backgroundColor,
            height: '100%',
            fontSize: 14,
            fontWeight: 300,
            fontFamily: 'Roboto,Roboto-Light',
        } }, children);
};
exports.default = StyleWrapper;
//# sourceMappingURL=StyleWrapper.js.map